import { render, staticRenderFns } from "./Collaterals.vue?vue&type=template&id=08b41656&scoped=true"
import script from "./Collaterals.vue?vue&type=script&lang=js"
export * from "./Collaterals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b41656",
  null
  
)

export default component.exports